import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { PublicLayout } from '@/components/layout/PublicLayout';
import { Card } from '@/components/ui/card';
import { api } from '@/lib/api';
import { Markdown } from '@/components/Markdown';
import { formatDateTime } from '@/lib/format';
import { AlertTriangle } from 'lucide-react';

const POLICY_LINKS = [
    { slug: 'refund', label: 'Refund Policy' },
    { slug: 'privacy', label: 'Privacy Policy' },
    { slug: 'fair-use', label: 'Fair Use Policy' },
    { slug: 'terms', label: 'Terms of Service' },
];

export default function PolicyPage() {
    const { slug } = useParams();
    const [policy, setPolicy] = useState(null);
    useEffect(() => {
        api.get(`/policies/${slug}`).then(r => setPolicy(r.data.policy)).catch(() => setPolicy({ error: true }));
    }, [slug]);

    return (
        <PublicLayout>
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-1 lg:grid-cols-4 gap-6">
                <aside className="lg:col-span-1">
                    <Card className="p-3 sticky top-20">
                        <div className="text-xs uppercase tracking-wider text-muted-foreground px-2 py-1">Legal</div>
                        <div className="mt-1 space-y-0.5">
                            {POLICY_LINKS.map((l) => (
                                <Link key={l.slug} to={`/policies/${l.slug}`} className={`block px-2 py-1.5 rounded-md text-sm ${slug === l.slug ? 'bg-secondary text-foreground font-medium' : 'text-muted-foreground hover:bg-secondary/60 hover:text-foreground'}`} data-testid={`policy-link-${l.slug}`}>{l.label}</Link>
                            ))}
                        </div>
                    </Card>
                </aside>
                <article className="lg:col-span-3">
                    {policy?.error ? (
                        <Card className="p-6"><div className="text-muted-foreground">Policy not found.</div></Card>
                    ) : !policy ? (
                        <Card className="p-6"><div className="text-muted-foreground">Loading...</div></Card>
                    ) : (
                        <Card className="p-6 sm:p-8" data-testid="policy-page-content">
                            <h1 className="font-display text-3xl font-semibold mb-1">{policy.title}</h1>
                            <div className="text-xs text-muted-foreground mb-5" data-testid="policy-page-last-updated">Last updated: {formatDateTime(policy.updated_at)}</div>
                            <div className="p-3 rounded-xl border mb-5" style={{ background: '#FFF7ED', borderColor: '#FED7AA' }}>
                                <div className="flex items-start gap-2 text-sm text-[#7C2D12]">
                                    <AlertTriangle className="h-4 w-4 mt-0.5" /> Digital goods are non-reversible. Entertainment use only - not for gambling or money games.
                                </div>
                            </div>
                            <Markdown content={policy.content} />
                        </Card>
                    )}
                </article>
            </div>
        </PublicLayout>
    );
}
